import { Box, Divider, Grid2, TextField } from "@mui/material";
import React, { useState } from "react";
import { CreateHandleUnsaveNavigation } from "../../../utilities/handleUnsaveNavigation";
import Loader from "../../../components/Loader";
import useNavigationGuard from "../../../hooks/useNavigationGuard";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { InfoOutlined } from "@mui/icons-material";
import SearchableSelect from "../../../components/SearchableSelect";

const BulkDrugKitStatus = () => {
  const [load, setLoad] = useState(false);
  const [numOfDrugs, setNumOfDrugs] = useState("");
  const roleId = localStorage.getItem("roleId");
  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const navigate = useNavigate();

  const createDrugAsignment = yup.object().shape({
    currentDrugKit: yup
      .string()
      .required("Current Drug Kit Status is required"),
    minSequenceNumber: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Min Sequence Number is not valid.")
      .required("Min Sequence Number is required"),
    maxSequenceNumber: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Max Sequence Number is not valid.")
      .required("Max Sequence Number  is required"),
    minKitNumber: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Min Kit Number is not valid.")
      .required("Min Kit Number is required"),
    maxKitNumber: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Max Kit Number is not valid.")
      .required("Max Kit Number  is required"),
    updateDrugStatus: yup.string().required("Update Drug Status is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(createDrugAsignment),
    defaultValues: {
      currentDrugKit: "",
      maxKitNumber: "",
      maxSequenceNumber: "",
      minKitNumber: "",
      minSequenceNumber: "",
      updateDrugStatus: "",
    },
  });

  useNavigationGuard(isDirty);

  const minSequenceRegister = register("minSequenceNumber");
  const maxSequenceRegister = register("maxSequenceNumber");
  const minKitRegister = register("minKitNumber");
  const maxKitRegister = register("maxKitNumber");

  const submitBulkDrugData = async (data) => {
    // console.log("Form Data: ", data);
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button
              className="bread-crumbs-btn"
              onClick={(e) => handleUnsaveNavigation(e, isDirty, "", navigate)}
            >
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                handleUnsaveNavigation(
                  e,
                  isDirty,
                  "drug-assignment-batch-release",
                  navigate
                );
              }}
            >
              Bulk Drug Kit Status Management
            </button>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={12} xs={12} sx={{ width: "100%" }}>
              <p className="page-heading"> Bulk Drug Kit Status Management</p>
              <Divider />
              <p className="page-sub-header">
                <InfoOutlined className="info-icon" />
                If you want to make an update to individual kits/units, please
                use the{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(
                      e,
                      isDirty,
                      "individual-drug-kit-status",
                      navigate
                    )
                  }
                  style={{ fontSize: "14px" }}
                >
                  Individual update function
                </button>
              </p>
            </Grid2>
          </Grid2>
          <Box
            component="form"
            autoComplete="off"
            sx={{ height: "auto", width: "100%" }}
            onSubmit={handleSubmit(submitBulkDrugData)}
          >
            <Grid2
              container
              alignItems="center"
              justifyContent={"space-between"}
              sx={{ width: "100%", margin: "0 auto", marginTop: "20px" }}
              gap={1}
            >
              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Current Drug Kit Status
                    <span>*</span>
                  </p>
                  {/* <                    name="currentDrugKit"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        id="currentDrugKit"
                        fullWidth
                        size="small"
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        {...field}
                        value={field.value || ""} // handle empty/default case
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                      </Select>
                    )}
                  /> */}
                  <SearchableSelect
                    control={control}
                    data={[]}
                    name={"currentDrugKit"}
                    optionKey="key"
                    optionLabel="value"
                  />
                </div>
                {errors.currentDrugKit && (
                  <div className="error-container">
                    {errors.currentDrugKit.message}
                  </div>
                )}
                {numOfDrugs !== "" && (
                  <div
                    style={{
                      marginTop: "4px",
                      fontSize: "small",
                      color: "#1976d2",
                    }}
                  >
                    {numOfDrugs} Drug Items Found
                  </div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Min Sequence Number
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="small"
                    type={"number"}
                    {...minSequenceRegister}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                      if (value !== "0") value = value.replace(/^0+/, ""); // Remove leading zeros
                      e.target.value = value;
                      minSequenceRegister.onChange(e);
                    }}
                  />
                </div>
                {errors.minSequenceNumber && (
                  <div className="error-container">
                    {errors.minSequenceNumber.message}
                  </div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Max Sequence Number
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="small"
                    type={"number"}
                    {...maxSequenceRegister}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                      if (value !== "0") value = value.replace(/^0+/, ""); // Remove leading zeros
                      e.target.value = value;
                      maxSequenceRegister.onChange(e);
                    }}
                  />
                </div>
                {errors.maxSequenceNumber && (
                  <div className="error-container">
                    {errors.maxSequenceNumber.message}
                  </div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Min Kit Number
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="small"
                    type={"number"}
                    {...minKitRegister}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                      if (value !== "0") value = value.replace(/^0+/, ""); // Remove leading zeros
                      e.target.value = value;
                      minKitRegister.onChange(e);
                    }}
                  />
                </div>
                {errors.minKitNumber && (
                  <div className="error-container">
                    {errors.minKitNumber.message}
                  </div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Max Kit Number
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="small"
                    type={"number"}
                    {...maxKitRegister}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                      if (value !== "0") value = value.replace(/^0+/, ""); // Remove leading zeros
                      e.target.value = value;
                      maxKitRegister.onChange(e);
                    }}
                  />
                </div>
                {errors.maxKitNumber && (
                  <div className="error-container">
                    {errors.maxKitNumber.message}
                  </div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Update Drug Status
                    <span>*</span>
                  </p>
                  <SearchableSelect
                    control={control}
                    data={[]}
                    name={"updateDrugStatus"}
                    optionKey="key"
                    optionLabel="value"
                  />
                </div>
                {errors.updateDrugStatus && (
                  <div className="error-container">
                    {errors.updateDrugStatus.message}
                  </div>
                )}
              </Grid2>
            </Grid2>

            <Grid2
              alignItems={"end"}
              justifyContent="end"
              container
              gap={3}
              sx={{ marginTop: "2%" }}
            >
              <Grid2 item md={6}>
                <button
                  type="button"
                  className="create-btn-outlined"
                  onClick={(e) => {
                    e.preventDefault();
                    handleUnsaveNavigation(e, isDirty, "", navigate);
                  }}
                >
                  Cancel
                </button>
              </Grid2>
              <Grid2 item md={6}>
                <button type="submit" className="create-btn">
                  Save
                </button>
              </Grid2>
            </Grid2>
          </Box>
        </div>
      )}
    </>
  );
};

export default BulkDrugKitStatus;
